import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function RevealSection() {
  return <section className="bg-[#0a0a0a] py-24 px-4 relative overflow-hidden" data-id="element-115">
      {/* Decorative background element */}
      <div className="absolute right-0 top-0 w-1/2 h-full bg-indigo-900/10 blur-[100px] pointer-events-none" data-id="element-116" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex justify-center mb-8" data-id="element-118">
          <div className="p-4 bg-indigo-500/10 rounded-2xl border border-indigo-500/20" data-id="element-119">
            <SparklesIcon className="w-10 h-10 text-indigo-400" data-id="element-120" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-center space-y-8" data-id="element-121">
          <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight" data-id="element-122">
            La verdad que nadie te dice es que{' '}
            <span className="text-indigo-400 underline decoration-indigo-500/50 underline-offset-4" data-id="element-123">
              no necesitas más seguidores
            </span>
            .
          </h2>

          <p className="text-xl text-gray-300 leading-relaxed" data-id="element-124">
            Necesitas una oferta propia y un sistema para venderla en piloto
            automático. Descubrimos que los creadores que realmente ganan $+5k
            USD al mes en Latam no son los que tienen más seguidores, sino los
            que poseen la <strong data-id="element-125">infografía de su propia audiencia</strong>.
          </p>

          <div className="p-8 bg-[#111111] rounded-2xl border border-white/5 shadow-xl mt-10" data-id="element-126">
            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-127">
              Hemos destilado este proceso en un "Sistema Operativo" (OS) que
              toma lo mejor de la Inteligencia Artificial y la automatización
              para que tú solo tengas que apretar un botón y empezar a ver
              conversiones reales.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}